import { Component } from '@angular/core';

@Component({
  selector: 'ml-sk-spinner-3',
  templateUrl: './sk-spinner-3.component.html',
  styleUrls: ['./sk-spinner-3.component.scss'],
  standalone: false,
})
export class SkSpinner3Component {}
